import React, { useState, useEffect } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { NAV_ITEMS, CONTACT } from '../mock';
import { Button } from './ui/button';

export default function Navbar({ onBook }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-colors ${scrolled ? 'bg-[#0a0a0f]/90 backdrop-blur border-b border-purple-900/40' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 md:h-[74px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full flex items-center justify-center text-white font-bold text-sm" style={{background:'linear-gradient(135deg,#a855f7,#ec4899)'}}>OS</div>
          <div className="leading-tight">
            <div className="font-extrabold tracking-wide text-white text-[15px] md:text-[17px]">ONE STOP <span className="gradient-text">CARZ</span></div>
            <div className="text-[11px] text-gray-400">{CONTACT.tagline}</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_ITEMS.map(n => (
            <a key={n.href} href={n.href} className="text-sm text-gray-300 hover:text-white transition-colors">{n.label}</a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <a href={`tel:+91${CONTACT.phone}`} className="hidden sm:inline-flex items-center gap-2 px-3 md:px-4 h-10 rounded-full border border-purple-800/60 text-gray-200 hover:border-pink-500/70 text-sm">
            <Phone className="w-4 h-4 text-pink-400" />{CONTACT.phone}
          </a>
          <Button onClick={onBook} className="gradient-btn rounded-full h-10 px-4 md:px-5 text-sm font-semibold">અત્યારે જ બુક કરો</Button>
          <button className="lg:hidden text-gray-200 ml-1" onClick={() => setOpen(!open)} aria-label="menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0a0a0f]/95 border-t border-purple-900/40 px-4 py-4">
          <div className="flex flex-col gap-3">
            {NAV_ITEMS.map(n => (
              <a key={n.href} href={n.href} onClick={() => setOpen(false)} className="text-gray-300 py-1">{n.label}</a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
